// extracted by mini-css-extract-plugin
export var container = "contact-module--container--ODSHL";
export var detailsContainer = "contact-module--detailsContainer--D2JW6";
export var contactDetail = "contact-module--contactDetail--gVNRP";
export var icon = "contact-module--icon--TRtFP";